import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './header.scss';

import { Build, DarkMode, MoreVert, ReportProblem, TimeToLeave, WbSunny } from '@mui/icons-material';
import MenuIcon from '@mui/icons-material/Menu';
import { Button, ButtonGroup, Menu, MenuItem, Tooltip } from '@mui/material';
import MuiAppBar, { AppBarProps as MuiAppBarProps } from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import { AUTHORITIES } from 'app/config/constants';
import { useAppSelector } from 'app/config/store';
import { hasAnyAuthority } from 'app/shared/auth/private-route';
import InProductionButton from 'app/shared/components/do-not-show-in-production/in-production-button.component';
import { ModalTestNewModules } from 'app/shared/components/modal-test-new-modules/ModalTestNewModules';
import { useAppThemeContext } from 'app/shared/contexts/ThemeContext';
import * as React from 'react';
import { useEffect, useState } from 'react';
import { Translate } from 'react-jhipster';
import { Link, useLocation } from 'react-router-dom';

export interface IHeaderProps {
  ribbonEnv: string;
  isInProduction: boolean;
  open: boolean;
  isAdmin: boolean;
  isDriver: boolean;
  isMaintenanceByCompany: boolean;
  setOpen?: (value: boolean) => void;
}

const drawerWidth = 310;
interface AppBarProps extends MuiAppBarProps {
  open?: boolean;
}

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: prop => prop !== 'open',
})<AppBarProps>(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(['width', 'margin'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

export const DefaultHeader = (props: IHeaderProps) => {
  const location = useLocation();
  const { themeName, toggleTheme } = useAppThemeContext();

  const isAdmin = useAppSelector(state => hasAnyAuthority(state.authentication.account.authorities, [AUTHORITIES.ADMIN]));
  const isManufacturerAdmin = useAppSelector(state => hasAnyAuthority(state.authentication.account.authorities, [AUTHORITIES.MANUFACTURER_ADMIN]));
  const isTransporterAdmin = useAppSelector(state => hasAnyAuthority(state.authentication.account.authorities, [AUTHORITIES.TRANSPORTER_ADMIN]));
  const { isOwner } = useAppSelector(state => state.authentication.account);

  const [anchorElNav, setAnchorElNav] = useState<null | HTMLElement>(null);
  const [allNews, setAllNews] = useState(false);

  const localAllNews = window.localStorage.getItem('AllNewsModal') === 'true' ? false : true;
  const initialTheme = localStorage.getItem('USER_THEME') as 'light' | 'dark' | null;

  const isActive = url => {
    return location.pathname === url;
  };

  const handleDrawer = () => {
    props.setOpen(!props.open);
  };

  const handleOpenNavMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElNav(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  useEffect(() => {
    if (localAllNews && (isAdmin || isManufacturerAdmin || isTransporterAdmin)) {
      setAllNews(!allNews);
      localStorage.setItem('AllNewsModal', 'true');
    }
  }, []);

  function changeLogo() {
    const img = initialTheme === 'dark' ? '../../../content/images/logo-sigaway-reduzido.png' : '../../../content/images/logo-sigaway-reduzido-dark.png';

    return (
      <Link to={props.isDriver ? '/truck-implement' : '/dashboards/company/truck-implements'}>
        <img src={img} className="logo-sigaway" alt="Logomarca Sigaway" style={{ height: '24px' }} />
      </Link>
    );
  }

  const defaultButtonHeaderStyles =
    initialTheme === 'dark'
      ? {
          mr: '40px',
          px: '20px',
          textTransform: 'none',
          borderRadius: '0px',
          '&:hover': {
            color: '#D5D5D5',
          },
        }
      : {
          mr: '40px',
          px: '20px',
          textTransform: 'none',
          opacity: '50%',
          borderRadius: '0px',
          color: '#000814',
          '&:hover': {
            color: '#000814',
            opacity: '100%',
          },
        };

  const activeButtonStylesHeader = {
    opacity: '100%',
    borderBottom: themeName === 'dark' ? 'solid #00EA80 4px' : 'solid #000814 4px',
    backgroundImage:
      themeName === 'dark' ? 'linear-gradient(rgba(6, 13, 31, 0.5), rgba(6, 13, 31, 0.5))' : 'linear-gradient(rgb(226,226,226), rgb(226,226,226))',
    color: themeName === 'dark' ? '#D5D5D5' : '#000814',
  };

  const countMaintenance = useAppSelector(state => state.dashboardCompany.countMaintenanceControl);

  const renderAlertMaintenance = () => {
    if (countMaintenance > 0) {
      return (
        <small className="text-warning ml-2 mt-n2">
          <FontAwesomeIcon icon="circle" size="xs" />
        </small>
      );
    }
    return null;
  };

  return (
    <>
      <AppBar position="sticky" open={props.open} sx={{ backgroundImage: 'none', backgroundColor: 'primary.main' }}>
        <Toolbar
          sx={{
            paddingLeft: { xs: '0px', md: '24px' },
            paddingRight: { xs: '0px', md: '24px' },
          }}
        >
          {(isAdmin || isManufacturerAdmin || isTransporterAdmin) && <ModalTestNewModules newsOpens={allNews} setNewsOpen={setAllNews} module={'AllNews'} />}
          {!props.open && (
            <Box sx={{ display: { xs: 'flex', md: 'none' } }}>
              <IconButton
                size="large"
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                onClick={handleDrawer}
                color={themeName === 'dark' ? 'inherit' : 'primary'}
                sx={{
                  ...defaultButtonHeaderStyles,
                  marginRight: '0px',
                }}
              >
                <MenuIcon />
              </IconButton>
            </Box>
          )}
          {!props.open && changeLogo()}
          <ButtonGroup sx={{ px: '24px' }}>
            <Tooltip title={themeName === 'light' ? 'Modo Escuro' : 'Modo Claro'} placement="bottom">
              <IconButton size="small" onClick={toggleTheme} color="secondary">
                {themeName === 'light' ? <DarkMode sx={{ opacity: '50%' }} /> : <WbSunny sx={{ fill: '#ABADC6' }} />}
              </IconButton>
            </Tooltip>
          </ButtonGroup>
          <InProductionButton />
          <Box sx={{ flexGrow: 1, justifyContent: 'flex-end', height: '64px', display: { xs: 'flex', md: 'none' } }}>
            {!props.open && (
              <IconButton
                size="large"
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                onClick={handleOpenNavMenu}
                color={themeName === 'dark' ? 'inherit' : 'primary'}
                sx={{
                  ...defaultButtonHeaderStyles,
                  marginRight: '0px',
                }}
              >
                <MoreVert />
              </IconButton>
            )}
            <Menu
              id="menu-appbar"
              anchorEl={anchorElNav}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              sx={{
                display: { xs: 'block', md: 'none' },
              }}
            >
              <MenuItem component={Link} to="/dashboards/company/truck-implements">
                <Typography fontWeight="500">
                  <Translate contentKey="global.menu.entities.asset">Assets</Translate>
                </Typography>
              </MenuItem>
              {(isAdmin || isTransporterAdmin) && (
                <MenuItem component={Link} to="/dashboards/company/alerts">
                  <Typography fontWeight={'500'}>
                    <Translate contentKey="global.menu.entities.alert">Alerts</Translate>
                  </Typography>
                </MenuItem>
              )}
              {(isAdmin || isTransporterAdmin) && (
                <MenuItem component={Link} to="/dashboards/company/maintenance-controls">
                  <Typography fontWeight={'500'}>
                    <Translate contentKey="global.menu.entities.maintenance">Maintenances</Translate>
                  </Typography>
                  {renderAlertMaintenance()}
                </MenuItem>
              )}
            </Menu>
          </Box>
          {/* Menu ||| iconButtons*/}
          {!props.isDriver && (
            <Box sx={{ flexGrow: 1, justifyContent: 'flex-end', height: '64px', display: { xs: 'none', md: 'flex' } }}>
              <Button
                component={Link}
                to="/dashboards/company/truck-implements"
                color={themeName === 'dark' ? 'inherit' : 'primary'}
                startIcon={<TimeToLeave sx={{ mr: 1 }} />}
                sx={{
                  ...defaultButtonHeaderStyles,
                  ...(isActive('/dashboards/company/truck-implements') ? activeButtonStylesHeader : {}),
                }}
              >
                <Typography fontWeight="500">
                  <Translate contentKey="global.menu.entities.asset">Assets</Translate>
                </Typography>
              </Button>
              {(isAdmin || isTransporterAdmin) && (
                <Button
                  component={Link}
                  to="/dashboards/company/alerts"
                  color={themeName === 'dark' ? 'inherit' : 'primary'}
                  startIcon={<ReportProblem sx={{ mr: 1 }} />}
                  sx={{
                    ...defaultButtonHeaderStyles,
                    ...(isActive('/dashboards/company/alerts') ? activeButtonStylesHeader : {}),
                  }}
                >
                  <Typography fontWeight={'500'}>
                    <Translate contentKey="global.menu.entities.alert">Alerts</Translate>
                  </Typography>
                </Button>
              )}
              {(isAdmin || isTransporterAdmin) && (
                <Button
                  component={Link}
                  to="/dashboards/company/maintenance-controls"
                  color={themeName === 'dark' ? 'inherit' : 'primary'}
                  startIcon={<Build sx={{ mr: 1 }} />}
                  sx={{
                    ...defaultButtonHeaderStyles,
                    ...(isActive('/dashboards/company/maintenance-controls') ? activeButtonStylesHeader : {}),
                  }}
                >
                  <Typography fontWeight={'500'}>
                    <Translate contentKey="global.menu.entities.maintenance">Maintenances</Translate>
                  </Typography>
                  {renderAlertMaintenance()}
                </Button>
              )}
            </Box>
          )}
        </Toolbar>
      </AppBar>
    </>
  );
};
